import groq from "groq"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqQueryOptions } from "../../shared/utils/groqQueryOptions"

/**
 * Retrieves bundles from Sanity
 *
 * @param {{ offset: number, limit: number, sort: { orderBy: string, direction: "asc"|"desc", caseSensitive?: boolean }, lang: string, cdn: boolean }} args
 * @returns {Object}
 */
export const queryBundles = {
  async bundles(_parent, args, context, _info) {
    const { offset = 0, limit = 25, sort, lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user } = context
    const sortByTitle = sort || { orderBy: "title", direction: "asc", caseSensitive: false }

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort: sortByTitle,
      offset,
      limit,
      includeDrafts: true,
    })

    const totalCountQuery = groq`count(*[_type=="bundle" ${draftsFilter}])`
    const bundlesQuery = groq`*[_type=="bundle" ${draftsFilter}]${pipesAndLimits}{
      "id": _id,
      title,
      image,
    }`

    const [totalCount, bundleItems] = await Promise.all([client.fetch(totalCountQuery), client.fetch(bundlesQuery)])

    return {
      total: totalCount,
      items: bundleItems,
    }
  },
}
